<template lang="pug">
#app-footer
  .footer-content
    .primary-footer.container.is-fluid.is-hidden-touch
      .columns
        .column.left-column.is-one-third
          ul.is-size-5-desktop.is-size-6-touch.mobile-margin
            li
              router-link(:to="{ name: 'services' }") Services
            li
              router-link(:to="{ name: 'calendar' }") Calendar
            li
              router-link(:to="{ name: 'ministries' }") Ministries
            li
              router-link(:to="{ name: 'believe' }") What We Believe
            li
              router-link(:to="{ name: 'staff' }") Our Staff
        .column.center-column.is-one-third
          .content
            p Contact Us
            .contact-links
              .contact-link
                b-icon(icon="map-marker-outline" size="is-small")
                span(v-html="account._embedded.location.address.html")
              .contact-link
                a(:href="`mailto:${account.email}`")
                  b-icon(icon="email-outline" size="is-small")
                  span {{ account.email }}
              .contact-link
                b-icon(icon="cellphone" size="is-small")
                span {{ account.phone_number }}
        .column.right-column.is-one-third
          .content
            p Connect with Us
            social-links(:value="account.social")
    .secondary-footer.container.is-fluid.has-text-grey
      .columns
        .column.left-column.is-one-third.is-hidden-touch
          .media
            .media-left(v-if="account.abbreviation === 'CWO'")
              img(src="/images/cwo/cwo-crest.png")
            .media-content
              small {{ account.organization }}
        .column.center-column.is-one-third.is-hidden-touch
          small &ldquo;{{ account.tagline }}&rdquo;
        .column.right-column.is-one-third
          social-links(v-if="isMobile" :value="account.social" email phone)
          small &copy; {{ currentYear }}. All Rights Reserved.
</template>

<script>
import { mapGetters } from 'vuex';
import SocialLinks from '@/components/SocialLinks.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'app-footer',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    currentYear() {
      return new Date().getFullYear();
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
  },
  components: {
    SocialLinks,
  },
};
</script>

<style lang="scss" scoped>
#app-footer {
  flex-shrink: 0;
  overflow: hidden;
  .footer-content {
    padding-top: 2.5rem;
    padding-bottom: 1.5rem;
    .primary-footer {
      ul {
        li {
          & + li {
            padding-top: 0.35rem;
          }
        }
      }
      .contact-links {
        .contact-link {
          display: flex;
          justify-content: center;
          align-items: center;
          & + .contact-link {
            margin-top: 1.25rem;
          }
          .icon {
            margin-right: 0.35rem;
          }
        }
      }
    }
    .secondary-footer {
      margin-top: 1.25rem;
      .columns {
        align-items: center;
        .column {
          min-height: 48px;
        }
      }
    }
    a {
      color: $white-ter;
      transition: 0.35s color ease-in-out;
      &:hover {
        color: $primary;
      }
    }
    .media {
      align-items: center;
      img {
        height: 38px;
        width: 38px;
      }
    }
  }
  .organization-logo {
    width: 180px;
    height: 180px;
    filter: grayscale(100%);
    opacity: 0.40;
  }
}
@media (min-width: $desktop) {
  #app-footer {
    // margin-top: 2.5rem;
    .columns {
      .column {
        &.left-column {
          text-align: left;
        }
        &.center-column {
          text-align: center;
        }
        &.right-column {
          text-align: right;
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  #app-footer {
    .footer-content {
      padding-bottom: 2.5rem;
      .primary-footer {
        ul {
          display: flex;
          flex-flow: wrap;
          justify-content: center;
          align-items: center;
          li {
            flex-grow: 1;
            padding: 1rem !important;
            text-align: center;
          }
        }
      }
      .secondary-footer {
        margin-top: 0;
      }
    }
    .columns {
      .column {
        padding: 0;
        text-align: center;
      }
    }
    .social-links {
      margin-bottom: 0.75rem;
    }
  }
}
</style>

<style theme="cwo" lang="scss">
#app-footer {
  background-color: $dark;
  color: $white-ter;
  .social-links {
    a {
      &:hover {
        color: $dark !important;
      }
    }
  }
}
</style>

<style theme="ffc" lang="scss">
#app-footer {
  background-color: $grey-lighter;
  color: $grey;
  a {
    color: $grey !important;
    transition: 0.35s color ease-in-out;
    &:hover {
      color: $theme-primary !important;
    }
  }
  .social-links {
    a {
      background-color: $grey-light;
      &:hover {
        color: $grey-lighter !important;
      }
    }
  }
}
</style>
